import React, { useState } from "react";
import Layout from "@/components/Layout";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Download, FileJson, FileSpreadsheet } from "lucide-react";
import { http } from "@/lib/api";

export default function Export() {
  const [week, setWeek] = useState(new Date().toISOString().slice(0, 10));

  const downloadJSON = async () => {
    const { data } = await http.get("/export/week", { params: { format: "json", week } });
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    triggerDownload(blob, `shopmerse_week_${data.export_metadata.week_start_date}.json`);
  };

  const downloadCSV = async (file) => {
    const res = await http.get("/export/week", {
      params: { format: "csv", file, week },
      responseType: "blob",
    });
    const filename = `${file}_${week}.csv`;
    triggerDownload(res.data, filename);
  };

  const triggerDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <Layout title="Weekly Export" subtitle="Pull any week's data for external review">
      <div className="max-w-3xl space-y-4">
        <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm">
          <Label className="text-xs uppercase font-semibold text-slate-600 tracking-wider">Anchor date (any day in the target week)</Label>
          <Input type="date" value={week} onChange={(e) => setWeek(e.target.value)} data-testid="export-week-anchor" className="mt-1.5 max-w-xs" />
          <div className="text-xs text-slate-500 mt-2">Week is computed Monday → Sunday from this date.</div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button onClick={downloadJSON}
                  data-testid="btn-download-json"
                  className="text-left p-6 bg-slate-900 text-white rounded-lg shadow-sm hover:bg-slate-800 transition-colors group">
            <FileJson className="w-6 h-6 text-amber-500 mb-3" />
            <div className="font-heading font-semibold text-lg">Full JSON Export</div>
            <div className="text-sm text-slate-400 mt-1">Combined bundle: metadata + leads + activity + standup.</div>
            <div className="text-xs text-amber-500 mt-4 flex items-center gap-1 group-hover:gap-2 transition-all">Download <Download className="w-3.5 h-3.5" /></div>
          </button>

          <div className="p-6 bg-white border border-slate-200 rounded-lg shadow-sm space-y-3">
            <FileSpreadsheet className="w-6 h-6 text-slate-700 mb-1" />
            <div className="font-heading font-semibold text-slate-900">CSV files</div>
            <div className="text-xs text-slate-500 mb-3">Separate CSV per collection.</div>
            <div className="grid gap-2">
              <Button variant="outline" onClick={() => downloadCSV("leads")} data-testid="btn-csv-leads">
                <Download className="w-4 h-4 mr-1.5" /> Leads
              </Button>
              <Button variant="outline" onClick={() => downloadCSV("activity")} data-testid="btn-csv-activity">
                <Download className="w-4 h-4 mr-1.5" /> Daily Activity
              </Button>
              <Button variant="outline" onClick={() => downloadCSV("standup")} data-testid="btn-csv-standup">
                <Download className="w-4 h-4 mr-1.5" /> Daily Standup
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
